export function applySimpleCrudQuery(query, input) {
  query.setLimit(typeof input.limit === 'number' ? input.limit : 0);
  if (input.fields) query.setFields(input.fields);
  if (input.filter) query.setFilter(input.filter);
  if (input.sort) query.setSortBy(input.sort);
  if (input.queryParams) {
    for (const paramName of Object.keys(input.queryParams)) {
      query.setCustomParam(paramName, input.queryParams[paramName]);
    }
  }
}